import { API } from "@/lib/api";

export function streamUrl(vid) {
  const token = localStorage.getItem("mlily_token");
  return `${API}/videos/${vid}/stream?auth=${encodeURIComponent(token || "")}`;
}

// True when the video has an uploaded file (vs a legacy external link)
export function isUploaded(v) {
  return !!v?.storage_path;
}
